module.exports = __webpack_public_path__ + "line-follow.png?61f072510aa0f8c8b709bde1ec268e36";